export const objMap = (obj, cb) => Object.keys(obj).reduce((acc, key) => ({
	...acc,
	[key]: cb(key, obj[key]),
}), {});

export const printObj = (obj) => JSON.stringify(obj, null, "  ");

export const promiseLog = (label) => (thing) => {
	console.log(label, thing);
	return thing;
}

export const plog = promiseLog;

export const cloneAllProps = obj => {
	const retval = {};
	Object.getOwnPropertyNames(obj).forEach(propName => {
		retval[propName] = obj[propName];
	});
	return retval;
};

export const delay = (t = 500) => o => (
	new Promise(resolve => {
		setTimeout(() => resolve(o), t);
	})
);


// WEBPACK FOOTER //
// ./src/lib/util.js